import React, { useEffect } from 'react';
import '../css/logoutPopUp.css'; // Adjust your file path if needed
import YourImage from '../images/logout-icon.png'; // Add your image path here

export default function ConfirmLogoutModal({ isOpen, onClose, onConfirm }) {


    useEffect(() => {
        if (isOpen) {
            const timer = setTimeout(() => {
                console.log('Function executed after 1 minute');
                onConfirm()
                // Call your desired function here
            }, 60000); // 60000 milliseconds = 1 minute

            // Cleanup function to clear the timeout if the component unmounts
            return () => clearTimeout(timer);
        }
    }, [])
    if (!isOpen) return null;
    return (
        <div className="modal-overlay1">
            <div className="modal-content1 modal-content1-timeout">
                {/* Close button "X" inside the inner box */}
                {/* <button className="modal-close1" onClick={onClose}>
                    &times;
                </button> */}

                {/* Image at the top */}
                <img src={YourImage} alt="Your Image" className="modal-top-image" />

                <h3 className='h3LogoutText h3TimeOutText'>Your session will be cleared in 2 minutes due to inactivity.</h3>

                <div className="modal-actions1">
                    <button className="btn-confirm1" onClick={onClose}>Keep Session</button>
                    <button className="btn-cancel1" onClick={onConfirm}>End Session</button>
                </div>
            </div>
        </div>
    );
}
